import { Component, inject, Input } from '@angular/core';
import { JobsService } from '../../services/jobs.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MaterialModule } from '../../material/material.module';
import { finalize } from 'rxjs';
import { AnimatedBackgroundComponent } from '../../components/animated-background/animated-background.component';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  imports: [CommonModule, RouterModule, ReactiveFormsModule, MaterialModule, AnimatedBackgroundComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  private readonly _api = inject(JobsService)
  private readonly _fb = inject(FormBuilder);
  private readonly _snackBar = inject(MatSnackBar)
  private readonly _router = inject(Router);

  @Input('token') token: any;

  loading: boolean = false;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  dataForm: FormGroup = this._fb.group({});

  ngOnInit(): void {
    console.log('token ', this.token);

    if (!this.token) {
      this.dataForm.addControl('email', this._fb.control(null, [Validators.required, Validators.email]))
    } else {
      this.dataForm.addControl('password', this._fb.control(null, Validators.required));
      this.dataForm.addControl('confirm_password', this._fb.control(null, Validators.required));
    }
  }

  sendLink() {
    if (this.loading || !this.dataForm.value.email) return;
    this.loading = true;
    this._api.forgotPassword({
      email: this.dataForm.value.email
    })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res: any) => {
          this._snackBar.open(res?.message || 'Reset password link has been sent to your email')
          this._router.navigate(['/login'])
        },
        error: (err: any) => {
          this._snackBar.open(err?.error?.message || "Unable to send link to email. Please try after sometime.")
        }
      })
  }

  updatePassword() {
    if (this.loading || this.dataForm.invalid) return;
    if (this.dataForm.value.password != this.dataForm.value.confirm_password) {
      this._snackBar.open("Passwords does not match, Please verify");
      return;
    }
    this.loading = true;
    this._api.resetPassword({
      token: this.token,
      new_password: this.dataForm.value.confirm_password
    })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res: any) => {
          this._snackBar.open(res?.message || "Password updated successfully");
          this._router.navigate(['/login'])
        },
        error: (err: any) => {
          this._snackBar.open(err?.error?.message || "Unable to send link to email. Please try after sometime.")
        }
      })
  }
}
